import { render, staticRenderFns } from "./employeesDeduction.vue?vue&type=template&id=1b297c72"
import script from "./employeesDeduction.vue?vue&type=script&lang=js"
export * from "./employeesDeduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports